var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page"},[(_vm.getAddChat)?_c('add-chat'):_vm._e(),_c('chat-settings'),(_vm.getInvite)?_c('modal-add-user'):_vm._e(),_c('modal-party'),_c('chat-list',{attrs:{"dialogs":_vm.chats,"loader":_vm.loader_list,"loader_more":_vm.loader_more}}),(_vm.$socket)?_c('chat-area'):_vm._e(),_c('modal-photos')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }